import { useLocation, useParams } from "react-router-dom"
import AppRedirectScreen from "../components/AppRedirectScreen"

function MomentScreen() {
  const { id } = useParams()
  const inviteCode = new URLSearchParams(useLocation().search).get("code")
  const query = inviteCode ? `?code=${encodeURIComponent(inviteCode)}` : ""

  return <AppRedirectScreen type="moment" deepLink={`pepchat://moments/${id}${query}`} />
}

export default MomentScreen
